import { Link } from 'react-router-dom';
import { type BoardLoad, driverName, formatDay, formatTime, statusLabel } from '@/pages/loads/board';

interface Props { rows: BoardLoad[]; compact: boolean }

export default function LoadsTable({ rows, compact }: Props) {
  return (
    <div className={`loads-table-scroll ${compact ? 'loads-compact' : ''}`} tabIndex={0} role="region" aria-label="Tabela de cargas, deslocável horizontalmente">
      <table className="loads-table">
        <caption className="sr-only">Cargas por estado, cliente, transporte e contacto</caption>
        <thead>
          <tr>
            <th scope="col">Estado</th>
            <th scope="col" title="Hora da última atualização, Portugal">HH:MM</th>
            <th scope="col">Carga / data</th>
            <th scope="col">Cliente</th>
            <th scope="col">Grade</th>
            <th scope="col">Embalagem</th>
            <th scope="col">Local</th>
            <th scope="col">Lote</th>
            <th scope="col">Transportador</th>
            <th scope="col">Matrículas</th>
            <th scope="col">Motorista</th>
            <th scope="col" className="text-right">Tel. / pager</th>
            <th scope="col"><span className="sr-only">Detalhe</span></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} data-state={row.status?.key ?? 'unset'}>
              <td className="loads-state-cell">
                <span className="inline-flex items-center gap-2 whitespace-nowrap font-semibold">
                  <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
                  {statusLabel(row.status)}
                </span>
              </td>
              <td className="tabular-nums"><time dateTime={row.updated_at}>{formatTime(row.updated_at)}</time></td>
              <td>
                <Link to={`/loads/${row.id}`} className="loads-order">{row.order_no}</Link>
                <span className="loads-cell-subtitle">{formatDay(row.load_date)}</span>
              </td>
              <td><span className="loads-cell-main" title={row.client ?? undefined}>{row.client || '—'}</span>
                {row.destination && <span className="loads-cell-subtitle" title={row.destination}>{row.destination}</span>}
              </td>
              <td className="font-semibold whitespace-nowrap">{row.grade || '—'}</td>
              <td><span className="loads-cell-main" title={row.packaging_type ?? undefined}>{row.packaging_type || '—'}</span></td>
              <td className="whitespace-nowrap">{row.loading_local || '—'}</td>
              <td><span className="loads-cell-main" title={row.lot?.join(', ')}>{row.lot?.join(', ') || '—'}</span></td>
              <td><span className="loads-cell-main" title={row.carrier?.name}>{row.carrier?.name || '—'}</span></td>
              <td className="whitespace-nowrap tabular-nums">
                {row.tractor?.registration || '—'}
                <span className="loads-cell-subtitle">{row.trailer?.registration || '—'}</span>
              </td>
              <td><span className="loads-cell-main" title={driverName(row)}>{driverName(row) || '—'}</span></td>
              <td className="text-right whitespace-nowrap">
                {row.phone ? (
                  <a href={`tel:${row.phone.replace(/[^+\d]/g, '')}`} className="loads-phone" aria-label={`Ligar para ${row.phone}`}>
                    <i className="ri-phone-line" aria-hidden="true" />{row.phone}
                  </a>
                ) : <span className="text-xs opacity-70">Sem telefone</span>}
                {row.pager != null && <span className="loads-cell-subtitle">Pager {row.pager}</span>}
              </td>
              <td><Link to={`/loads/${row.id}`} aria-label={`Abrir carga ${row.order_no}`} className="loads-open"><i className="ri-arrow-right-up-line" aria-hidden="true" /></Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
